/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_New_Source_Qty_LabelInputs */

const vi_scl_new_source_qty_label = /** @type {(inputs: Scl_New_Source_Qty_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KL xuất từ lô nguồn (kg)`)
};

/**

* @param {Scl_New_Source_Qty_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_new_source_qty_label = /** @type {((inputs?: Scl_New_Source_Qty_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_New_Source_Qty_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_new_source_qty_label(inputs)
});